const tsDataReading = {
  scale1: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale2: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale3: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale4: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale5: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale6: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale7: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale8: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale9: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale10: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale11: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale12: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale13: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale14: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale15: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale16: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale17: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale18: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale19: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale20: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale21: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale22: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale23: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale24: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale25: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale26: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale27: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale28: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale29: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale30: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale31: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale32: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale33: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale34: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale35: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  },
  scale36: {
    "Passport to Advanced Math": 0.0552,
    "Nonlinear equations": 0.1035,
    "Nonlinear functions": 0.0069,
    "Equivalent expressions": 0.035567,
    "Heart of Algebra": 0.0654639,
    "Linear equations, two variables": 0.0345361,
    "Linear functions": 0.1035,
    "Linear equations, one variable": 0.042268,
    "Systems of equations": 0.0552,
    "Linear inequalities": 0.0123711,
    "Problem Solving and Data Analysis": 0.0069,
    "Models and scatterplots": 0.042268,
    Probability: 0.1035,
    "Center and spread": 0.0552,
    "Statistical claims": 0.035567,
    Percentages: 0.042268,
    "Inference from statistics": 0.0123711,
    "Rates, proportions, and units": 0.0654639,
    "Additional Topics in Math": 0.0069,
    "Complex numbers": 0.0552,
    "Lines, angles, and triangles": 0.1035,
    Circles: 0.035567,
    "Right triangles and trig": 0.0123711,
    "Area and volume": 0.035567
  }
}

export default tsDataReading
